import { render, staticRenderFns } from "./ArrearsTransactionEdit.vue?vue&type=template&id=37f6cc2c"
import script from "./ArrearsTransactionEdit.vue?vue&type=script&lang=js"
export * from "./ArrearsTransactionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports